var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcStartpoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.60095 10.5085C3.60095 10.8649 4.11739 11.1489 4.45749 11.0425C4.87973 10.9104 5.47918 10.7992 6.30095 10.7992C8.32595 10.7992 9.67595 12.1492 11.701 12.1492C13.2315 12.1492 13.9908 11.7636 14.2704 11.5753C14.3584 11.516 14.401 11.4146 14.401 11.3085V4.3399C14.401 3.98354 13.8845 3.69955 13.5444 3.80595C13.1222 3.93806 12.5227 4.04922 11.701 4.04922C9.67595 4.04922 8.32595 2.69922 6.30095 2.69922C4.77041 2.69922 4.01108 3.08482 3.73152 3.27314C3.64353 3.3324 3.60095 3.43382 3.60095 3.5399V10.5085Z",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.60095 16.5212V11.4785",
    stroke: "#B7B7B7",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStartpoint);
export default __webpack_public_path__ + "static/media/ic_startpoint.85e65bc625f99ae46656328519bfaafe.svg";
export { ForwardRef as ReactComponent };